import React, { useEffect, useState } from 'react';

import { Alert, ConfigProvider, GetProps, Input, Space, Typography } from 'antd';

import { StarOutlined } from '@ant-design/icons';


type TextAreaProps = GetProps<typeof Input.TextArea>;

interface Props extends TextAreaProps {
    createIssueAi: (value: string) => void;
    setIsTyping: (typing: boolean) => void;
}

export function CreationAiTextAreaSuggestions({ createIssueAi, setIsTyping, ...restProps }: Props) {
    const [value, setValue] = useState<string>('');

    useEffect(() => {
        const timeout = setTimeout(() => {
            createIssueAi(value);
        }, 1000);

        return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const message = (
        <Space direction='vertical' style={{ width: '100%' }}>
            <Space>
                <StarOutlined size={16} style={{ color: 'var(--ant-purple-6)' }} />

                <Typography.Text style={{ color: 'purple' }} strong>
                    Criar com Gcondo.ai
                </Typography.Text>
            </Space>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Descreva o problema ou crie um checklist, informando nome do responsável, prazo, que o a IA prenche os campos.
            </Typography.Text>
        </Space>

    );

    const description =
        <Space direction="vertical" style={{ width: '100%' }}>
            <ConfigProvider
                theme={{
                    components: {
                        Radio: {
                            colorBgBase: 'var(--ant-purple-1)',
                            colorBorder: 'var(--ant-purple-3)',
                            colorPrimary: 'var(--ant-purple-6)',
                            colorPrimaryActive: 'var(--ant-purple-6)',
                            colorPrimaryHover: 'var(--ant-purple-6)',
                        }
                    }
                }}>
                <Input.TextArea {...restProps} onChange={(e) => {
                    setIsTyping(true);
                    setValue(e.target.value);
                }} />
            </ConfigProvider>
        </Space>;

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Alert
                showIcon={false}
                message={message}
                description={description}
                style={{
                    padding: '8px 12px',
                    backgroundColor: 'var(--ant-purple-1)',
                    borderColor: 'var(--ant-purple-3)',
                    fontSize: 12,
                }}
            />


        </Space>
    );
}
